exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[popup][data-v-5b9904b4]{z-index:999;position:absolute;left:0;top:0;right:auto;bottom:auto;width:100%}[popup] .dim[data-v-5b9904b4]{position:fixed;left:0;top:0;right:auto;bottom:auto;width:100%;height:120%;background:rgba(0,0,0,.6);z-index:50}[popup] .holder[data-v-5b9904b4]{position:absolute;left:0;top:0;right:auto;bottom:auto;z-index:51;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b9904b4","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/Popup.vue
// module id = IILu
// module chunks = 241